var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "agent-list" } },
    [
      _vm.assignAgent
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "assign-agent",
                title: _vm.$t("message.addRepresentative"),
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.assignAgent = false
                },
              },
            },
            [
              _c("JoinableAgent", {
                attrs: { contact: _vm.contact },
                on: {
                  close: function ($event) {
                    _vm.assignAgent = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.forwardAgent
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "forward-agent",
                title: _vm.$t("message.forwardChat"),
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.forwardAgent = false
                },
              },
            },
            [
              _c("ChatForwardWindow", {
                attrs: { contact: _vm.contact },
                on: {
                  close: function ($event) {
                    _vm.forwardAgent = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.preferredAgentModal
        ? _c("PreferredAgents", {
            attrs: { "modal-enabled": true, visitorId: _vm.contact._id },
            on: {
              cancel: function ($event) {
                _vm.preferredAgentModal = false
              },
            },
            model: {
              value: _vm.preferredAgents,
              callback: function ($$v) {
                _vm.preferredAgents = $$v
              },
              expression: "preferredAgents",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "agent-list-groups" }, [
        _c("div", { staticClass: "agent-list-group" }, [
          _c("div", { staticClass: "agent-list-group-head" }, [
            _c("div", { staticClass: "agent-list-group-head-title" }, [
              _vm._v(_vm._s(_vm.$t("calendar.agents"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "agent-list-group-head-actions" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom-end" },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end' }",
                    },
                  ],
                  staticClass: "agent-list-group-head-actions-item",
                  attrs: { content: _vm.$t("message.forwardRep") },
                  on: {
                    click: function ($event) {
                      _vm.forwardAgent = true
                    },
                  },
                },
                [
                  _c("div", { staticClass: "material-icons" }, [
                    _vm._v("fast_forward"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom-end" },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end' }",
                    },
                  ],
                  staticClass: "agent-list-group-head-actions-item",
                  attrs: { content: _vm.$t("message.addRepresentative") },
                  on: {
                    click: function ($event) {
                      _vm.assignAgent = true
                    },
                  },
                },
                [_c("div", { staticClass: "material-icons" }, [_vm._v("add")])]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "agent-list-group-content" },
            _vm._l(_vm.agents, function (agent) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                        delay: [600, 0],
                      },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                    },
                  ],
                  key: agent._id,
                  staticClass: "agent-list-group-content-item",
                  attrs: { content: agent.name },
                  on: {
                    click: function ($event) {
                      return _vm.writeAgent(agent)
                    },
                  },
                },
                [
                  _c(
                    "a-popover",
                    {
                      attrs: {
                        placement: "bottomLeft",
                        trigger: "click",
                        overlayClassName: "user-options",
                      },
                    },
                    [
                      _c("template", { slot: "content" }, [
                        _c("div", { staticClass: "content" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-row mt-3 pb-2 user-options-item",
                              staticStyle: {
                                "border-bottom": "1px solid #f1f4f7",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "justify-content-start" },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("message"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "justify-content-end pl-3 cursorPointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.startDM(agent._id)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("tour.startChat")) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-row mt-3 pb-2 user-options-item",
                              staticStyle: {
                                "border-bottom": "1px solid #f1f4f7",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "justify-content-start" },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("query_stats"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "justify-content-end pl-3 cursorPointer",
                                  on: { click: _vm.goToAgentReport },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t("chatWindow.goToAgentReport")
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-row mt-3 pb-2 user-options-item",
                              staticStyle: {
                                "border-bottom": "1px solid #f1f4f7",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "justify-content-start" },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("info"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "justify-content-end pl-3 cursorPointer",
                                  on: { click: _vm.goToUserList },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("chatWindow.agentDetail")) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-row mt-3 user-options-item",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "justify-content-start" },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("list"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "justify-content-end pl-3 cursorPointer",
                                  on: { click: _vm.goToUserList },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("chatWindow.agentList")) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "material-icons more-icon" }, [
                        _vm._v("more_vert"),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("AgentAvatar", { attrs: { userID: agent._id, size: 40 } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "agent-details" }, [
                    _c("div", { staticClass: "agent-name" }, [
                      _vm._v(_vm._s(agent.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "agent-status" }, [
                      _c(
                        "div",
                        { staticClass: "in-chat" },
                        [
                          _c("md-icon", { staticClass: "icon" }, [
                            _vm._v(" sms "),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("message.inChat"))),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "agent-list-group" }, [
          _c("div", { staticClass: "agent-list-group-head" }, [
            _c("div", { staticClass: "agent-list-group-head-title" }, [
              _vm._v(_vm._s(_vm.$t("message.prefferedAgents"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "agent-list-group-head-actions" },
              [
                _vm.showSlidingPanel
                  ? _c("SlidingPanel", {
                      staticClass: "sliding-panel",
                      attrs: {
                        visitorId: _vm.contact._id,
                        preferredAgents: _vm.preferredAgents,
                      },
                      on: {
                        close: _vm.closeSlidingPanel,
                        select: _vm.handleAgentSelect,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticClass: "agent-list-group-head-actions-item",
                    attrs: { content: _vm.$t("message.addRepresentative") },
                    on: { click: _vm.openSlidingPanel },
                  },
                  [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("edit"),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "preferred-agent-list-group-content" }, [
            !_vm.getPreferredAgents().length && !_vm.showSlidingPanel
              ? _c(
                  "div",
                  { staticClass: "no-preferred-agents" },
                  [
                    _c("NoPreferredAgent", {
                      on: { openSelectModal: _vm.openSlidingPanel },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "preferred-agent-list-group-list" },
                  _vm._l(_vm.getPreferredAgents(), function (agent) {
                    return !_vm.showSlidingPanel
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                  delay: [600, 0],
                                },
                                expression:
                                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                              },
                            ],
                            key: agent._id,
                            staticClass:
                              "preferred-agent-list-group-content-item",
                            attrs: { content: agent.name },
                          },
                          [
                            _c("AgentAvatar", {
                              attrs: { userID: agent._id, size: 40 },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "preferred-agent-details" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "preferred-agent-name" },
                                  [_vm._v(_vm._s(agent.name))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "preferred-agent-departments",
                                  },
                                  _vm._l(agent.subjects, function (subject) {
                                    return _c(
                                      "span",
                                      {
                                        key: subject._id,
                                        attrs: { color: "#8796af" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.getContentFromLanguageContent(
                                                subject
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  0
                ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }